<template
  ><div class="gm-stack">
    <nav class="gm-tabs" aria-label="Form publishing options">
      <button
        v-for="item in ['Embed', 'HTML', 'Popup']"
        :key="item"
        :class="{ active: mode === item }"
        @click="mode = item"
      >
        {{ item }}
      </button>
    </nav>
    <label class="gm-field"
      >{{
        mode === 'Embed'
          ? 'Embed code'
          : mode === 'HTML'
          ? 'Raw HTML form'
          : 'Popup button code'
      }}<textarea
        :value="code"
        readonly
        rows="7"
        aria-label="Form embed code"/></label
    ><gs-button variant="outline" @click="copy"
      >Copy {{ mode === 'HTML' ? 'HTML' : 'code' }}</gs-button
    ><small aria-live="polite">{{ notice }}</small>
    <p class="gm-muted">
      {{
        mode === 'HTML'
          ? 'Raw HTML adopts your website layout and redirects after submission. Copy it again after changing fields. Use Embed to keep the live form design in sync.'
          : mode === 'Popup'
          ? 'Paste this button and script where you want the popup to open. The live form opens with the Groove modal controls.'
          : 'The embedded form stays in sync when you publish changes. Adjust the iframe height for your page layout.'
      }}
    </p>
    <label v-if="mode === 'Popup'" class="gm-field"
      >Popup button text<input v-model="document.design.button.label" /><small
        >Save changes, then copy your popup code.</small
      ></label
    >
  </div></template
>
<script>
import { embedMarkup } from './contracts';
import { rawFormMarkup, popupMarkup } from './form-embeds';
export default {
  props: { id: String, name: String, document: Object },
  data: () => ({ mode: 'Embed', notice: '' }),
  computed: {
    code() {
      if (this.mode === 'HTML')
        return rawFormMarkup(
          this.id,
          this.document,
          window.config.apiUrl || window.location.origin + '/groovemail'
        );
      if (this.mode === 'Popup')
        return popupMarkup(this.id, this.name, this.document.design.button);
      return embedMarkup(this.id, this.name);
    }
  },
  methods: {
    async copy() {
      try {
        await navigator.clipboard.writeText(this.code);
        this.notice = 'Code copied.';
      } catch (error) {
        this.notice = 'Select the code above and copy it.';
      }
    }
  }
};
</script>
